import config from "@/config";
import http from "@/utils/request";

export default {
	data: {
		// 生成出勤单
		generateAttendance: {
			url: `${config.MAIN_URL}/api/v1/jw/jwAttendance/generate`,
			name: '出勤单生成',
			get: async function () {
				return await http.get(this.url);
			},
		},
		// 添加数据
		add: {
			url: `${config.MAIN_URL}/api/v1/jw/jwAttendance/generate`,
			name: '出勤单生成',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		// 修改数据
		update: {
			url: `${config.MAIN_URL}/api/v1/jw/jwAttendance`,
			name: '出勤单修改',
			put: async function (params) {
				return await http.put(this.url, params);
			},
		},
		// 历史查询
		history: {
			url: `${config.MAIN_URL}/api/v1/jw/jwAttendance`,
			name: '出勤单查询',
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		// 出勤单批量修改
		addList: {
			url: `${config.MAIN_URL}/api/v1/jw/jwAttendance/addList`,
			name: '出勤单批量修改',
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		// 飞机位置
		getplace: {
			url: `${config.MAIN_URL}/api/v1/jwHangarPlane`,
			name: '飞机位置',
			get: async function (params) {
				return await http.get(this.url, params);
			},
		}
	}
}
